"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Config = void 0;
var Logger_1 = require("../utils/Logger");
Object.defineProperty(exports, "LogLevel", { enumerable: true, get: function () { return Logger_1.LogLevel; } });
var Config = (function () {
    function Config() {
    }
    return Config;
}());
exports.Config = Config;
exports.default = Config;
//# sourceMappingURL=Config.js.map